<template>
    <div id="hsid-login">
        <section v-if="showYellowSection" class="bg--yellow">
            <div class="container banner-security">
                <div>
                    <button class="close" @click="closeYellowSection"></button>
                    <h4>Your security is our top priority.</h4>
                    <br>
                    <p class="mb-0">You will need a HealthSafe ID in order to log in to your myCompass account. Using a HealthSafe ID gives you access to many of your health benefits with just one username and password. Use it whenever you see the HealthSafe ID name.</p>
                    <br>
                    <p class="mb-0"> If you've ever had a HealthSafe ID, you don't need to create a new login. You can use the same username and password to sign in. Don't have a HealthSafe ID? Registration is easy.
                        <a :href="registerRoute">Create HealthSafe ID <i class="fa-external-link-straight"></i></a>
                    </p>
                </div>
            </div>
        </section>
        <section class="bg--blue">
            <div class="container">
                <div class="row flex-column align-items-center">
                    <h2 class="text-center">myCompass Member Login</h2>
                    <div class="card-body">
                        <a :href="redirectRoute" class="btn btn-block hsid-login__btn">Sign in to myCompass <i class="fa-arrow"></i></a>
                        <p class="mb-0 text-center text-md-left">Need to Register? <span class="d-block d-md-inline"><a :href="registerRoute">Create HealthSafe ID<i class="fa-external-link-straight"></i></a></span></p>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: 'HsidLogin',
    props: {
        registerRoute: {
            type: String,
            required: true
        },
        redirectRoute: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            showYellowSection: true,
        }
    },
    methods: {
        closeYellowSection() {
            this.showYellowSection = false;
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
